module.exports = __webpack_public_path__ + "assets/255ae1a2ac830dad73d1ce42003be9df.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level4_WinKP35V1_17.mp3
 ** module id = 394
 ** module chunks = 0
 **/